module.exports = __webpack_public_path__ + "img/brands-light.92389697.png";